export const DASHBOARD_I18N_PREFIX = "features.home.components.dashboard";

export const DASHBOARD_I18N_KEYS = {
  overview:  "overview",
  add_chart: "add_chart",
  posts:     "posts",
  comments:  "comments",
  tweets:    "tweets",
  headlines: "headlines",
  data_compliance_agreement: "data_compliance_agreement",
  social_media_data: "social_media_data",
  uploaded_data: "uploaded_data",
  total_data_points: "total_data_points"
}


// WEBPACK FOOTER //
// ./src/features/home/components/constants/i18n/Dashboardi18nConstants.js